import axios from "axios"
import { IGetArticlesRequest, IGetArticlesResponse } from "./article.model"

export const getArticles = async (
  url: string,
  data: IGetArticlesRequest,
): Promise<IGetArticlesResponse> => {
  const payload: IGetArticlesRequest = data

  const response = await axios.get<IGetArticlesResponse>(url, { params: payload })

  return response.data
}
